const style = {
  mainLayoutContainer: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#0D1117",
    color: "#E6EDF3",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  backgroundGlow: {
    position: "absolute",
    top: "-20%",
    left: "10%",
    width: "800px",
    height: "800px",
    background:
      "radial-gradient(circle, rgba(88, 166, 255, 0.15) 0%, rgba(88, 166, 255, 0) 60%)",
    zIndex: 0,
  },
  backgroundLogo: {
    position: "absolute",
    top: "50%",
    marginLeft: "200px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "800px",
    height: "800px",
    zIndex: 0,
  },
  contentArea: {
    flexGrow: 1,
    padding: "40px 50px",
    marginLeft: "280px",
    boxSizing: "border-box",
    overflowY: "auto",
    height: "100vh",
    zIndex: 1,
  },
};

export default style;
